import { render, staticRenderFns } from "./SignDocument.vue?vue&type=template&id=5b8ee5b7&lang=html&"
import script from "./SignDocument.vue?vue&type=script&lang=js&"
export * from "./SignDocument.vue?vue&type=script&lang=js&"
import style0 from "./SignDocument.vue?vue&type=style&index=0&id=5b8ee5b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports